import get from 'lodash/get';
import { useTheme } from 'native-base';
import { Platform, Text } from 'react-native';
import { CustomRendererProps, TBlock } from 'react-native-render-html';

import { useMessaging } from 'app/providers/MessagingProvider';

const extractText = (node: any): string => {
  if (node?.type === 'text') return node.data || '';
  if (node?.children) return node.children.map(extractText).join('');
  return '';
};

export default function OpenChat({
  TDefaultRenderer,
  tnode,
  ...props
}: CustomRendererProps<TBlock>) {
  const { open } = useMessaging();
  const theme = useTheme();

  if (Platform.OS === 'ios') {
    const linkColor = get(theme.colors, 'brand.active') as string;
    return (
      <Text
        accessibilityRole="link"
        accessible
        style={{ color: linkColor, textDecorationLine: 'underline' }}
        onPress={open}
      >
        {extractText(tnode.domNode)}
      </Text>
    );
  }

  return <TDefaultRenderer {...props} tnode={tnode} onPress={open} />;
}
